module.exports = __webpack_public_path__ + "img/index-9.e7afaab2.png";